<template>
  <div class="panel-body">
    <div class="left">
      <div class="">
        <fieldset class="border">
          <legend class="border">メールアドレス変更</legend>
          <form data-vv-scope="form-1">
            <div class="form-group flexbox">
              <label class="control-label flex-item flex-lable flexbox justify-between label-width-2">メールアドレス</label>
              <div class="flex-item flex-input">
                <input type="text" class="form-control" disabled :value="data.email">
              </div>
            </div>
            <div class="form-group flexbox">
              <label class="control-label flex-item flex-lable flexbox justify-between label-width-2">変更後メールアドレス
                <span class="text-danger m-r-sm">＊</span>
              </label>
              <div class="flex-item flex-input">
                <span style="display: block" v-show="errors.has('form-1.email')" class="text-danger">※{{ errors.first('form-1.email') }}</span>
                <input type="text" class="form-control" data-vv-name="email" data-vv-scope="form-1" v-validate="'required|email|max:150'" v-model="dataEmail.email" data-vv-as="変更後メールアドレス">
              </div>
            </div>
            <div class="form-group flexbox">
              <label class="control-label flex-item flex-lable flexbox justify-between label-width-2">変更後メールアドレス（確認）
                <span class="text-danger m-r-sm">＊</span>
              </label>
              <div class="flex-item flex-input">
                <span style="display: block" v-show="errors.has('form-1.confirmEmail')" class="text-danger">※{{ errors.first('form-1.confirmEmail') }}</span>
                <input type="text" class="form-control" data-vv-name="confirmEmail" data-vv-scope="form-1" v-validate="'required|email|max:150'" v-model="dataEmail.confirmEmail" data-vv-as="変更後メールアドレス（確認）">
              </div>
            </div>
            <div class="update-btn">
              <button class="btn btn-warning w-120" @click.prevent="updateEmail('form-1')" :disabled="disableEmail">更新</button>
            </div>
          </form>
        </fieldset>
      </div>
      <div class="mr-t-10">
        <fieldset class="border">
          <legend class="border">パスワード変更</legend>
          <p>※パスワードは、8文字以上英数字で入力して下さい。</p>
          <form data-vv-scope="form-2">
            <div class="form-group flexbox">
              <label class="control-label flex-item flex-lable flexbox justify-between label-width-2">現在のパスワード
                <span class="text-danger m-r-sm">＊</span>
              </label>
              <div class="flex-item flex-input">
                <span style="display: block" v-show="errors.has('form-2.password')" class="text-danger">※{{ errors.first('form-2.password') }}</span>
                <input type="password" class="form-control" data-vv-name="password" data-vv-scope="form-2" v-validate="'required|alpha_num|max:64|min:8'" v-model="dataPassword.oldPassword" data-vv-as="パスワード">
              </div>
            </div>
            <div class="form-group flexbox">
              <label class="control-label flex-item flex-lable flexbox justify-between label-width-2">変更後パスワード
                <span class="text-danger m-r-sm">＊</span>
              </label>
              <div class="flex-item flex-input">
                <span style="display: block" v-show="errors.has('form-2.newPassword')" class="text-danger">※{{ errors.first('form-2.newPassword') }}</span>
                <input type="password" class="form-control" data-vv-name="newPassword" data-vv-scope="form-2" v-validate="'required|alpha_num|max:64|min:8'" v-model="dataPassword.newPassword" data-vv-as="変更後パスワード">
              </div>
            </div>
            <div class="form-group flexbox">
              <label class="control-label flex-item flex-lable flexbox justify-between label-width-2">変更後パスワード（確認）
                <span class="text-danger m-r-sm">＊</span>
              </label>
              <div class="flex-item flex-input">
                <span style="display: block" v-show="errors.has('form-2.confirmNewPassword')" class="text-danger">※{{ errors.first('form-2.confirmNewPassword') }}</span>
                <input type="password" class="form-control" data-vv-name="confirmNewPassword" data-vv-scope="form-2" v-validate="'required|alpha_num|max:64|min:8'" v-model="dataPassword.confirmNewPassword" data-vv-as="変更後パスワード（確認）">
              </div>
            </div>
            <div class="update-btn">
              <button class="btn btn-warning w-120" @click.prevent="updatePassword('form-2')" :disabled="disablePassword">更新</button>
            </div>
          </form>
        </fieldset>
      </div>
    </div>
  </div>
</template>
<script>
import Const from '@/common/msg'
import SettingService from '@/services/settingservice'
import store from '@/store'
import { mapGetters } from 'vuex'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      disablePassword: true,
      disableEmail: true,
      data: [],
      dataPassword: {
        oldPassword: null,
        newPassword: null,
        confirmNewPassword: null
      },
      dataEmail: {
        email: null,
        confirmEmail: null
      },
      err: null,
      isUpdated: false,
      loader: null
    }
  },

  created () {
    this.getLoginInfor()
  },

  computed: {
    ...mapGetters({
      isShowModal: 'getIsShowModal'
    })
  },

  methods: {
    async getLoginInfor () {
      let self = this
      let response = await SettingService.loginInfor().catch(error => {
        this.err = error
      })
      if (response) {
        self.data = response
      }
      if (this.$route.params.tab === 'login-info') {
        this.$events.fire('done')
      }
    },

    async updateEmail (scope) {
      let self = this
      let logParams = {
        name: eventCode.settings.login_info_tab.click_update_email_button,
        properties: {
          oldEmail: this.data.email,
          newEmail: this.dataEmail.email,
          newConfirmEmail: this.dataEmail.confirmEmail
        }
      }
      EventService.postTrackLog(logParams)

      let updateEmailMsg = Const.updateEmailSuccess
      let result = await this.$validator.validateAll(scope)
      if (result) {
        self.loader = this.$loading.show()
        if (self.dataEmail.email !== self.dataEmail.confirmEmail) {
          updateEmailMsg = Const.duplicateMail
          self.clearError(scope)
        } else {
          let response = await SettingService.loginInforChangeEmail(self.dataEmail)
            .catch(error => {
              updateEmailMsg = error
              self.clearError(scope)
            })
          if (response) {
            self.isUpdated = true
          }
        }
        self.loader.hide()
        this.$store.commit('toggleModal', {
          show: true,
          message: updateEmailMsg
        })
      }
    },

    async updatePassword (scope) {
      let self = this

      let logParams = {
        name: eventCode.settings.login_info_tab.click_update_password_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      let _dataPassword = {}
      _dataPassword.record = self.dataPassword

      let updatePasswordMsg = Const.updateSuccess
      let result = await this.$validator.validateAll(scope)
      if (result) {
        const loader = this.$loading.show()
        if (self.dataPassword.newPassword !== self.dataPassword.confirmNewPassword) {
          updatePasswordMsg = Const.updateFail
          self.clearError(scope)
        } else {
          let response = await SettingService.loginInforChangePassword(_dataPassword).catch(error => {
            updatePasswordMsg = error
            self.clearError(scope)
          })
          if (response) {
            self.isUpdated = true
          }
        }
        loader.hide()
        this.$store.commit('toggleModal', {
          show: true,
          message: updatePasswordMsg
        })
      }
    },

    doLogout () {
      store.dispatch('doLogout')
      this.$router.push('/login')
    },

    // call when update failed
    clearError (scope) {
      if (scope === 'form-1') {
        this.dataEmail.email = null
        this.dataEmail.confirmEmail = null
      } else {
        this.dataPassword.oldPassword = null
        this.dataPassword.newPassword = null
        this.dataPassword.confirmNewPassword = null
      }
      let matcher = {
        scope: scope,
        vmId: this.$validator.id
      }
      this.$validator.reset(matcher)
    },

    async checkDisableButton (scope) {
      let result = false
      if (scope === 'form-1') {
        result = (await this.$validator.validate('form-1.email', this.dataEmail.email, {silent: true}) &&
                  await this.$validator.validate('form-1.confirmEmail', this.dataEmail.confirmEmail, {silent: true}))
      } else {
        result = (await this.$validator.validate('form-2.password', this.dataPassword.password, {silent: true}) &&
                  await this.$validator.validate('form-2.newPassword', this.dataPassword.newPassword, {silent: true}) &&
                  await this.$validator.validate('form-2.confirmNewPassword', this.dataPassword.confirmNewPassword, {silent: true}))
      }
      return !result
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'login-info') {
      let logParams = {
        name: eventCode.settings.login_info_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },

  watch: {
    dataEmail: {
      handler () {
        let self = this
        this.checkDisableButton('form-1')
          .then((response) => {
            self.disableEmail = response
          })
      },
      deep: true
    },

    dataPassword: {
      handler () {
        let self = this
        this.checkDisableButton('form-2')
          .then((response) => {
            self.disablePassword = response
          })
      },
      deep: true
    },

    isShowModal (newVal, oldVal) {
      if (!newVal && this.isUpdated) {
        this.doLogout()
      }
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/setting/LoginInfo.vue